import { BarLocation, BarsResponse, MapBounds, Region } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Fetch bars within bounds (legacy - for viewport filtering)
export async function fetchBarsInBounds(bounds: MapBounds): Promise<BarsResponse> {
  const query = new URLSearchParams({
    north: String(bounds.north),
    south: String(bounds.south),
    east: String(bounds.east),
    west: String(bounds.west),
  });

  const res = await fetch(`${API_BASE_URL}/api/bars?${query.toString()}`);
  if (!res.ok) throw new Error('Failed to fetch bars');
  return (await res.json()) as BarsResponse;
}

// Fetch bars for a specific region (city)
export async function fetchBarsByRegion(regionSlug: string): Promise<BarsResponse> {
  const res = await fetch(`${API_BASE_URL}/api/bars?region=${encodeURIComponent(regionSlug)}`);
  if (!res.ok) throw new Error('Failed to fetch bars');
  return (await res.json()) as BarsResponse;
}

/**
 * Resolve a shared bar link to the city whose map holds it.
 *
 * Returns null for a bar that no longer exists, which is an ordinary outcome
 * for a link someone shared months ago — not an error worth throwing over.
 */
export async function fetchBarLocation(barId: string): Promise<BarLocation | null> {
  const res = await fetch(`${API_BASE_URL}/api/bars/${encodeURIComponent(barId)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error('Failed to locate bar');
  return (await res.json()) as BarLocation;
}

// Fetch all available regions
export async function fetchRegions(): Promise<Region[]> {
  const res = await fetch(`${API_BASE_URL}/api/regions`);
  if (!res.ok) throw new Error('Failed to fetch regions');
  const data = await res.json();
  return data.regions as Region[];
}
